import React from "react";
import { Card, Typography } from "@material-ui/core";
import WarningIcon from "@mui/icons-material/Warning";
import useStyles from "./styles";

const DeniedAccess = () => {
  const classes = useStyles();

  return (
    <div>
      <Card raised className={classes.deniedAccessCard}>
        <div className={classes.deniedHeaderDiv}>
          <WarningIcon className={classes.warningIcon} />
          <Typography className={classes.deniedAccessTitle}>
            Access Denied
          </Typography>
        </div>
        <div className={classes.deniedTextDiv}>
          <Typography className={classes.deniedAccessMessage}>
            You do not have permission to access this page.
          </Typography>
          <Typography className={classes.deniedAccessMessage}>
            Please contact your administrator if you believe this is an error.
          </Typography>
          <Typography className={classes.deniedAccessMessage}>
            Thank you for your understanding.
          </Typography>
          <Typography className={classes.deniedAccessMessage}>
            Setup Remodeling Team
          </Typography>
        </div>
      </Card>
    </div>
  );
};

export default DeniedAccess;
